export const MAX_FILE_SIZE = 20; // MB
